<template>
    <div>
        <div class="vx-row w-full mt-3" v-if="(globalDataAreaChartKeywords || globalDataAreaChartTopKeywords)">
            <vx-card>
                <!-- LINE AREA CHART -->
                <div
                    class="vx-col w-full mb-base globalDataChart"
                    v-if="(globalDataAreaChartKeywords || globalDataAreaChartTopKeywords) && keywordDataLength > 0"
                >
                <div class="vx-row">
                    <div class="vx-col">
                    <h4 class="pt-3">{{ perfTitle }}</h4>
                    </div>
                    <div class="vx-col">
                    <vx-tooltip text="Source des données : Google Search Console">
                        <vs-avatar text="?" style="cursor: default;"></vs-avatar>
                    </vx-tooltip>
                    </div>
                </div>
                <vs-tabs ref="gscTabs" v-model="gscTabsIndex">

                    <!-- KEYWORDS GLOBAL -->
                    <vs-tab label="Keywords" id="gsc-keywords" ref="gsc-keywords" class="vs-con-loading__container">
                    <apexchart
                        v-if="globalDataAreaChartKeywords && globalDataAreaChartKeywords.chartOptions && globalDataAreaChartKeywords.series"
                        ref="globalDataChartKeywords"
                        type="area"
                        height="350"
                        :options="globalDataAreaChartKeywords.chartOptions"
                        :series="globalDataAreaChartKeywords.series"
                    ></apexchart>

                    <div class="vx-row mt-4"  v-if="globalSiteDataKeywords">
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="show('Impressions', false)">
                        <vx-tooltip
                            title="Impressions"
                            text="Nombre de fois où votre site a été affiché(e) dans les résultats de recherche."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base Impressions pointer"
                            style="box-shadow: 0px 0px 10px 2px #28C76F;"
                            icon="ServerIcon"
                            icon-right
                            :statistic="globalSiteDataKeywords.impressions == 0 ? 0 : formatThousandNumb(globalSiteDataKeywords.impressions)"
                            statisticTitle="Impressions"
                            color="success"
                            />
                        </vx-tooltip>
                        </div>

                        <div
                        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4"
                        @click="show('Clics')"
                        >
                        <vx-tooltip
                            title="Clics"
                            text="Nombre de clics sur votre site par un moteur de recherche."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base Clics pointer"
                            style="box-shadow: 0px 0px 10px 2px #7367F0;"
                            icon="CpuIcon"
                            colorTo="primary"
                            icon-right
                            :statistic="globalSiteDataKeywords.clicks == 0 ? 0 : formatThousandNumb(globalSiteDataKeywords.clicks)"
                            statisticTitle="Clics"
                            />
                        </vx-tooltip>
                        </div>



                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="show('CTR', false)">
                        <vx-tooltip
                            title="CTR"
                            text="Pourcentage de clics par rapport au nombre d'impressions."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base CTR pointer"
                            style="box-shadow: 0px 0px 10px 2px #EA5455;"
                            icon="ActivityIcon"
                            colorTo="primary"
                            icon-right
                            :statistic="formatValue(globalSiteDataKeywords.ctr, 2) + '%'"
                            statisticTitle="CTR"
                            color="danger"
                            />
                        </vx-tooltip>
                        </div>

                        <div
                        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="show('Position', false)"
                        >
                        <vx-tooltip
                            title="Position Moyenne"
                            text="Position moyenne sur le mois."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base Position pointer"
                            style="box-shadow: 0px 0px 10px 2px #FF9F43;"
                            icon="AlertOctagonIcon"
                            icon-right
                            :statistic="formatValue(globalSiteDataKeywords.position, 0)"
                            statisticTitle="Position Moyenne"
                            color="warning"
                            />
                        </vx-tooltip>
                        </div>

                    </div>
                    <div class="vx-row">
                        <div class="vx-col pt-2">
                        <span>Nombre de lignes affichées : </span>
                        </div>
                        <div class="vx-col">
                        <vs-select
                            autocomplete
                            v-model="keywordsAndTkListingMaxRow"
                            class="select-large pb-4"
                        >
                            <vs-select-item
                            :key="index"
                            :value="item"
                            :text="item"
                            v-for="(item, index) in pageNumberOptions"
                            class="w-full"
                            />
                        </vs-select>
                        </div>
                        <div class="vx-col pt-2">
                            <span>Recherche par keyword : </span>
                        </div>
                        <div class="vx-col">
                            <vs-input class="inputx" placeholder="Keyword" v-model="keywordSearchInput"  />
                        </div>
                    </div>
                        <vs-table ref="keywordTable" v-if="keywordListingFull && keywordListingFull.data" stripe hoverFlat auto-resize pagination :max-items="keywordsAndTkListingMaxRow" noDataText="" :data="keywordListingFull.data" class="mt-2">
                        <template slot="thead">
                            <vs-th class="text-center" style="width: 20px;"> </vs-th>
                            <vs-th class="text-center" style="width: 20px;"> </vs-th>
                            <vs-th class="text-center" sort-key="keyword">Keyword</vs-th>
                            <vs-th sort-key="impressions" class="px-2" style="width: 60px;"><vs-spacer/>Impressions</vs-th>
                            <vs-th sort-key="clicks" class="px-2" style="width: 60px;"><vs-spacer/>Clics</vs-th>
                            <vs-th sort-key="ctr" class="px-2" style="width: 60px;"><vs-spacer/>CTR</vs-th>
                            <vs-th sort-key="position" class="px-2" style="width: 60px;"><vs-spacer/>Position Moyenne</vs-th>
                            <vs-th sort-key="last_position" class="px-2" style="width: 60px;"><vs-spacer/><span>Dernière Position</span></vs-th>
                            <vs-th sort-key="diff" class="px-2" style="width: 60px;"><vs-spacer/><span>Δ</span></vs-th>
                            <vs-th sort-key="potential" class="px-2" style="width: 60px;"><vs-spacer/><span>Potentiel</span><vs-spacer/></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="index" v-for="(row, index) of data">
                            <vs-td>
                                <vx-tooltip v-if="!isBrand(row.keyword)" text="Ajouter dans les marques" style="display: inline-block; width: 20px;"><vs-icon @click="addBrand(row.keyword)" icon="add_circle_outline" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                                <vx-tooltip v-else text="Retirer des marques" style="display: inline-block; width: 20px;"><vs-icon @click="removeBrand(row.keyword)" icon="business" color="#470D93" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                            </vs-td>
                            <vs-td>
                                <vx-tooltip v-if="!isTopKeyword(row.keyword)" text="Ajouter dans les top keywords" style="display: inline-block; width: 20px;"><vs-icon @click="addTopKeyword(row.keyword)" icon="star_border" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                                <vx-tooltip v-else text="Retirer des top keywords" style="display: inline-block; width: 20px;"><vs-icon @click="removeTopKeyword(row.keyword)" icon="grade" color="#FFC90E" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                            </vs-td>
                            <vs-td>
                                <span @click="showLineChartPopup(row.keyword)" class="hvr-underline hvr-underline-out" style="cursor: pointer;"><strong>{{ row.keyword }}</strong></span>
                                <a :href="convertKeywordToGoogleSearchUrl(row.keyword)" target='_blank' class="hvr-underline hvr-underline-out"><vs-icon icon="open_in_new" size="small" style="font-size: 1rem; height: 0.8rem;" /></a>
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.impressions == 0 ? 0 : formatThousandNumb(row.impressions) }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.clicks == 0 ? 0 : formatThousandNumb(row.clicks) }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.ctr.toFixed(2) + '%' }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.position > 0 ? Math.round(row.position / row.counter) : 0 }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                <span>{{ row.last_position }}</span>
                            </vs-td>
                            <vs-td class="txt_align_right">
                                <span v-if="row.diff && row.diff > 0" style="color: green;"><span style="font-size:1.5rem !important;">↑</span>{{  String(Math.abs(row.diff)) }}</span>
                                <span v-else-if="row.diff && row.diff < 0" style="color: red;"><span style="font-size:1.5rem !important;">↓</span>{{ String(Math.abs(row.diff)) }}</span>
                                <span v-else-if="row.diff && row.diff == 0" style="color: red;"><span style="font-size:1.5rem !important;">→</span></span>
                                <span v-else>{{ row.diff ? row.diff : " " }}</span>
                            </vs-td>
                            <vs-td class="txt_align_right pl-6" style="display:flex; justify-content: right;">
                                <vs-chip
                                    style="color: white; border-radius: 8px;width: 65px; margin-right: 20px;"
                                    :color="computeResultColorFromDifference(8, 176, 185, row.potential, false)"
                                >
                                    <!-- < style="font-size: 1rem;">{{ row.potential }}</span> -->
                                </vs-chip>
                            </vs-td>
                            </vs-tr>
                        </template>
                        </vs-table>

                    </vs-tab>
                    <!-- TOP KEYWORDS GLOBAL -->
                    <vs-tab label="Top Keywords" id="gsc-top-keywords" ref="gsc-top-keywords" class="vs-con-loading__container">

                    <apexchart
                        v-if="globalDataAreaChartTopKeywords && globalDataAreaChartTopKeywords.chartOptions && globalDataAreaChartTopKeywords.series"
                        ref="globalDataChartTopKeywords"
                        type="area"
                        height="350"
                        :options="globalDataAreaChartTopKeywords.chartOptions"
                        :series="globalDataAreaChartTopKeywords.series"
                    ></apexchart>

                    <div class="vx-row mt-4" v-if="globalSiteData">
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="show('Impressions', true)">
                        <vx-tooltip
                            title="Impressions"
                            text="Nombre de fois où votre site a été affiché(e) dans les résultats de recherche."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base Impressions pointer"
                            style="box-shadow: 0px 0px 10px 2px #28C76F;"
                            icon="ServerIcon"
                            icon-right
                            :statistic="globalSiteData.impressions == 0 ? 0 : formatThousandNumb(globalSiteData.impressions)"
                            statisticTitle="Impressions"
                            color="success"
                            />
                        </vx-tooltip>
                        </div>

                        <div
                        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4"
                        @click="show('Clics', true)"
                        >
                        <vx-tooltip
                            title="Clics"
                            text="Nombre de clics sur votre site par un moteur de recherche."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base Clics pointer"
                            style="box-shadow: 0px 0px 10px 2px #7367F0;"
                            icon="CpuIcon"
                            colorTo="primary"
                            icon-right
                            :statistic="globalSiteData.clicks == 0 ? 0 : formatThousandNumb(globalSiteData.clicks)"
                            statisticTitle="Clics"
                            />
                        </vx-tooltip>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="show('CTR', true)">
                        <vx-tooltip
                            title="CTR"
                            text="Pourcentage de clics par rapport au nombre d'impressions."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base CTR pointer"
                            style="box-shadow: 0px 0px 10px 2px #EA5455;"
                            icon="ActivityIcon"
                            colorTo="primary"
                            icon-right
                            :statistic="formatValue(globalSiteData.ctr, 2) + '%'"
                            statisticTitle="CTR"
                            color="danger"
                            />
                        </vx-tooltip>
                        </div>

                        <div
                        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="show('Position', true)"
                        >
                        <vx-tooltip
                            title="Position Moyenne"
                            text="Position moyenne sur le mois."
                            position="top"
                        >
                            <statistics-card-line
                            hideChart
                            class="mb-base Position pointer"
                            style="box-shadow: 0px 0px 10px 2px #FF9F43;"
                            icon="AlertOctagonIcon"
                            icon-right
                            :statistic="formatValue(globalSiteData.position, 0)"
                            statisticTitle="Position Moyenne"
                            color="warning"
                            />
                        </vx-tooltip>
                        </div>

                    </div>
                    <div class="vx-row">
                        <div class="vx-col pt-2">
                        <span>Nombre de lignes affichées : </span>
                        </div>
                        <div class="vx-col">
                        <vs-select
                            autocomplete
                            v-model="keywordsAndTkListingMaxRow"
                            class="select-large pb-4"
                        >
                            <vs-select-item
                            :key="index"
                            :value="item"
                            :text="item"
                            v-for="(item, index) in pageNumberOptions"
                            class="w-full"
                            />
                        </vs-select>
                        </div>
                        <div class="vx-col pt-2">
                            <span>Recherche par keyword : </span>
                        </div>
                        <div class="vx-col">
                            <vs-input class="inputx" placeholder="Keyword" v-model="topKeywordSearchInput"  />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col py-2">
                            <strong>Nombre de top keywords : {{ tkTableLength }}</strong>
                        </div>

                        <div class="vx-col py-2">
                            <strong>Volume de recherche total : {{ tkTableTotalVolume }}</strong>
                        </div>
                    </div>
                        <vs-table ref="topKeywordTable" v-if="topKeywordListingFull && topKeywordListingFull.data" stripe hoverFlat auto-resize pagination :max-items="keywordsAndTkListingMaxRow" noDataText="" :data="topKeywordListingFull.data" class="mt-2">
                        <template slot="thead">
                            <vs-th class="text-center" style="width: 20px;"> </vs-th>
                            <vs-th class="text-center" style="width: 20px;"> </vs-th>
                            <vs-th class="text-center" sort-key="keyword">Keyword</vs-th>
                            <vs-th class="text-center px-2" sort-key="volume" style="width: 60px;"><vs-spacer/>Recherches mensuelles</vs-th>
                            <vs-th sort-key="impressions" class="px-2" style="width: 60px;"><vs-spacer/>Impressions</vs-th>
                            <vs-th sort-key="clicks" class="px-2" style="width: 60px;"><vs-spacer/>Clics</vs-th>
                            <vs-th sort-key="ctr" class="px-2" style="width: 60px;"><vs-spacer/>CTR</vs-th>
                            <vs-th sort-key="position" class="px-2" style="width: 60px;"><vs-spacer/>Position Moyenne</vs-th>
                            <vs-th sort-key="last_position" class="px-2" style="width: 60px;"><vs-spacer/><span>Dernière Position</span></vs-th>
                            <vs-th sort-key="diff" class="px-2" style="width: 60px;"><vs-spacer/><span>Δ</span></vs-th>
                            <vs-th sort-key="kd" class="px-2" style="width: 60px;"><vs-spacer/>
                                <vx-tooltip text="Keyword DIfficulty/Competition Index">
                                KD
                                </vx-tooltip>
								<vs-spacer/>
                            </vs-th>
                            <vs-th sort-key="potential" class="px-2" style="width: 60px;"><vs-spacer/><span>Potentiel</span><vs-spacer/></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="index" v-for="(row, index) of data">
                            <vs-td>
                                <vx-tooltip v-if="!isBrand(row.keyword)" text="Ajouter dans les marques" style="display: inline-block; width: 20px;"><vs-icon @click="addBrand(row.keyword)" icon="add_circle_outline" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                                <vx-tooltip v-else text="Retirer des marques" style="display: inline-block; width: 20px;"><vs-icon @click="removeBrand(row.keyword)" icon="business" color="#470D93" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                            </vs-td>
                            <vs-td>
                                <vx-tooltip v-if="!isTopKeyword(row.keyword)" text="Ajouter dans les top keywords" style="display: inline-block; width: 20px;"><vs-icon @click="addTopKeyword(row.keyword)" icon="star_border" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                                <vx-tooltip v-else text="Retier des top keywords" style="display: inline-block; width: 20px;"><vs-icon @click="removeTopKeyword(row.keyword)" icon="grade" color="#FFC90E" class="hvr-underline hvr-underline-out" /></vx-tooltip>
                            </vs-td>
                            <vs-td>
                                <span @click="showLineChartPopup(row.keyword)" class="hvr-underline hvr-underline-out" style="cursor: pointer;"><strong>{{ row.keyword }}</strong></span>
                                <a :href="convertKeywordToGoogleSearchUrl(row.keyword)" target='_blank' class="hvr-underline hvr-underline-out"><vs-icon icon="open_in_new" size="small" style="font-size: 1rem; height: 0.8rem;" /></a>
                            </vs-td>
                            <vs-td class="txt_align_right">
                                <span v-if="row.volume < 0"><vs-icon icon="schedule" size="small" color="primary" /></span>
                                <span v-else>{{ row.volume == 0 ? 0 : formatThousandNumb(row.volume) }}</span>
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.impressions == 0 ? 0 : formatThousandNumb(row.impressions) }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.clicks == 0 ? 0 : formatThousandNumb(row.clicks) }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.ctr.toFixed(2) + '%' }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                {{ row.position > 0 ? Math.round(row.position / row.counter) : 0 }}
                            </vs-td>
                            <vs-td class="txt_align_right">
                                <span>{{ row.last_position }}</span>
                            </vs-td>
                            <vs-td class="txt_align_right">
                                <span v-if="row.diff && row.diff > 0" style="color: green;"><span style="font-size:1.5rem !important;">↑</span>{{ String(Math.abs(row.diff)) }}</span>
                                <span v-else-if="row.diff && row.diff < 0" style="color: red;"><span style="font-size:1.5rem !important;">↓</span>{{ String(Math.abs(row.diff)) }}</span>
                                <span v-else-if="row.diff && row.diff == 0" style="color: red;"><span style="font-size:1.5rem !important;">→</span></span>
                                <span v-else>{{ row.diff ? row.diff : " " }}</span>
                            </vs-td>
                            <vs-td class="txt_align_right pl-6"><vs-chip
                                    style="color: white; border-radius: 8px; width: 35px; margin-right: 20px;"
                                    :color="computeResultColorFromDifferenceKD(61, 219, 80, 252, 186, 3, 204, 41, 87, row.kd)"
                                >{{ row.kd }}</vs-chip></vs-td>
                            <vs-td class="txt_align_right pl-6" style="display:flex; justify-content: right;">
                                <vs-chip
                                    style="color: white; border-radius: 8px; width: 65px; margin-right: 20px;"
                                    :color="computeResultColorFromDifference(8, 176, 185, row.potential, true)"
                                >
                                    <span style="font-size: 1rem;">{{ row.potential }}</span>
                                </vs-chip>
                            </vs-td>

                            </vs-tr>
                        </template>
                        </vs-table>

                    </vs-tab>
                </vs-tabs>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
import utilsMixin from "@/mixins/utilsMixin";
import chartsMixin from "@/mixins/chartsMixin";
import StatisticsCardLine from "@/components/views/dashboard/statistics-cards/StatisticsCardLine.vue";
export default {
	name: "KeywordsSearchConsole",
	mixins: [utilsMixin, chartsMixin],
	components: {
		StatisticsCardLine
	},
	props: {
		apiUrl: {
			type: String,
			default: ""
		},
		fromDate: {
			type: String,
			default: "",
		},
		toDate: {
			type: String,
			default: "",
		},
		brands: {
			type: Array,
			default: () => []
		},
		globalSiteData: {
			type: Object,
			default: null
		},
		globalSiteDataKeywords: {
			type: Object,
			default: null
		},
		globalDataAreaChartKeywords: {
			type: Object,
			default: null
		},
		globalDataAreaChartTopKeywords: {
			type: Object,
			default: null
		},
		keywordListingFull: {
			type: Object,
			default: null
		},
		topKeywordListingFull: {
			type: Object,
			default: null
		},
		topKeywords: {
			type: Array,
			default: () => []
		},
		keywordData: { //Object.keys(keywordData).length
			type: Array,
			default: () => []
		},
		keywordDataLength: { //Object.keys(keywordData).length
			type: Number,
			default: 0
		},
		perfTitle: {
			type: String,
			default: "Performances cumulées des Keywords et Top Keywords"
		},
		pageNumberOptions: {
			type: Array,
			default: () => []
		},
		societyId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			keywordSearchInput: "",
			topKeywordSearchInput: "",
			keywordsAndTkListingMaxRow: 25,
			gscTabsIndex: 0,
			isMarque: false,
			tkTableLength: 0,
			tkTableTotalVolume: 0
		};
	},
	created() {
		this.countTkTableLengthAndTotalVolume();
	},
	watch: {
		keywordSearchInput: function(data){
			this.$refs.keywordTable.searchx = data;
			this.isMarque = false;
		},
		topKeywordSearchInput: function(data){
			this.$refs.topKeywordTable.searchx = data;
			// //console.log("topKeywordSearchInput")
			//console.log("topKeywordSearchInput", this.$refs.topKeywordTable.datax.length);
			this.countTkTableLengthAndTotalVolume(data);
		},
		/*
		 * maxRowMultiplicatorTKSERP: function(data){
		 *     this.$emit("update-max-row-multiplicator-tk-serp", data)
		 * },
		 */
	},
	methods: {
		computeResultColorFromDifference(r, g, b, value, isTop){
			let opacity;
			let maxPotential;
			let minPotential;
			if(!isTop){
				maxPotential = Math.max.apply(Math, this.keywordListingFull.data.map((o) => {
					return o.potential;
				}));
				minPotential = Math.min.apply(Math, this.keywordListingFull.data.map((o) => {
					return o.potential;
				}));

			}
			else{
				maxPotential = Math.max.apply(Math, this.topKeywordListingFull.data.map((o) => {
					return o.potential;
				}));
				minPotential = Math.min.apply(Math, this.topKeywordListingFull.data.map((o) => {
					return o.potential;
				}));
			}

			opacity = Number((Number(value) / (maxPotential - ((maxPotential - minPotential) / 2)))).toFixed(4);
			if(opacity <= 0.25) opacity = "25%";
			else opacity = opacity * 100 + "%";
			return `rgba(${r}, ${g}, ${b}, ${opacity})`;
		},
		computeResultColorFromDifferenceKD(r, g, b, r2, g2, b2, r3, b3, g3, value){
			let returnedColor = {
				r: 0,
				g: 0,
				b: 0
			};
			let maxKd = 100;
			let midKd = 50;
			let minKd = 0;
			if(value <= minKd){
				returnedColor.r = r;
				returnedColor.g = g;
				returnedColor.b = b;
			}
			else if(value <= midKd){
				let colorChangePercentage = ((value - minKd)) / (midKd - minKd);
				let colorMinMidDiff = {
					rdiff: r - r2,
					gdiff: g - g2,
					bdiff: b - b2
				};
				returnedColor.r = r - ((colorMinMidDiff.rdiff * colorChangePercentage));
				returnedColor.g = g - ((colorMinMidDiff.gdiff * colorChangePercentage));
				returnedColor.b = b - ((colorMinMidDiff.bdiff * colorChangePercentage));
			}
			else if(value >= maxKd){
				returnedColor.r = r3;
				returnedColor.g = g3;
				returnedColor.b = b3;
			}
			else{
				let colorChangePercentage = ((value - midKd)) / (maxKd - midKd);
				let colorMidMaxDiff = {
					rdiff: r2 - r3,
					gdiff: g2 - g3,
					bdiff: b2 - b3
				};
				returnedColor.r = r2 - ((colorMidMaxDiff.rdiff * colorChangePercentage));
				returnedColor.g = g2 - ((colorMidMaxDiff.gdiff * colorChangePercentage));
				returnedColor.b = b2 - ((colorMidMaxDiff.bdiff * colorChangePercentage));
			}
			return `rgb(${returnedColor.r}, ${returnedColor.g}, ${returnedColor.b})`;
		},
		countTkTableLengthAndTotalVolume(searchString=""){
			let tkCounter = 0;
			let tkTotalVolume = 0;
			if(searchString){
				for(let index = 0; index < this.$props.topKeywordListingFull.data.length; index++){
					if(this.$props.topKeywordListingFull.data[index].keyword.includes(searchString)){
						tkCounter +=1;
						tkTotalVolume += this.$props.topKeywordListingFull.data[index].volume;
					}
				}
				this.tkTableLength = tkCounter;
				this.tkTableTotalVolume = tkTotalVolume;
			}
			else{
				if(this.$props.topKeywordListingFull.data && this.$props.topKeywordListingFull.data.length > 0){
					this.tkTableLength = this.$props.topKeywordListingFull.data.length;
					for(let index = 0; index < this.$props.topKeywordListingFull.data.length; index++){
						tkTotalVolume += this.$props.topKeywordListingFull.data[index].volume;
					}
					this.tkTableTotalVolume = tkTotalVolume;
				}
				else{
					this.tkTableLength = 0;
					this.tkTableTotalVolume = 0;
				}
			}
		},
		resetMarque(){
			this.keywordSearchInput = "";
			this.topKeywordSearchInput = "";
		},
		isTopKeyword(keyword){
			let lcTopKeyword = this.$props.topKeywords.map(e => e.toLowerCase());
			if(lcTopKeyword.indexOf(keyword) >= 0){
				return true;
			}
		},
		addTopKeyword(keyword){
			this.$emit("add-top-keyword", keyword);
		},
		removeTopKeyword(keyword){
			this.$emit("remove-top-keyword", keyword);
		},
		isBrand(keyword){
			let lcBrands = this.$props.brands.map(e => e.toLowerCase());
			if(lcBrands.indexOf(keyword) >= 0){
				return true;
			}
		},
		addBrand(keyword){
			let list = [keyword];
			for(let i = 0; i < this.topKeywordListingFull.data.length; i++){
				if(this.topKeywordListingFull.data[i].keyword.toLowerCase() !== keyword && this.topKeywordListingFull.data[i].keyword.toLowerCase().indexOf(keyword) >= 0){
					list.push(this.topKeywordListingFull.data[i].keyword);
				}
			}
			this.$emit("add-brand", list);
		},
		removeBrand(keyword){
			this.$emit("remove-brand", keyword);
		},
		/**
		 * Display or hide a series on the main chart (IMP, POS, CTR, CLICK)
		 * @param {string} name - Name of the series to show or hide
		 */
		show(name, topKeywordBool) { // FAIRE KEYWORDS ET TOPKEYWORDS AVEC SHOW ET UN ARGUMENT
			let chartName = topKeywordBool ? "globalDataChartTopKeywords" : "globalDataChartKeywords";
			let currentElement = document.getElementsByClassName(
				"vx-card overflow-hidden mb-base " + name
			)[0];
			/*
			 * let areaChartLegendItem = document.getElementsByClassName( // TODO ???
			 *     "apexcharts-legend-text"
			 * );
			 */
			//console.log(this.$refs[chartName]);
			switch(name) {
			case"Impressions":
				if(currentElement.style.boxShadow == "") {
					currentElement.style.boxShadow = "0px 0px 10px 2px #28C76F";
					this.$refs[chartName].showSeries(name);
				}
				else{
					currentElement.style.boxShadow = "";
					this.$refs[chartName].hideSeries(name);
				}
				break;
			case"Clics":
				if(currentElement.style.boxShadow == "") {
					currentElement.style.boxShadow = "0px 0px 10px 2px #7367F0";
					this.$refs[chartName].showSeries(name);
				}
				else{
					currentElement.style.boxShadow = "";
					this.$refs[chartName].hideSeries(name);
				}
				break;
			case"CTR":
				if(currentElement.style.boxShadow == "") {
					currentElement.style.boxShadow = "0px 0px 10px 2px #EA5455";
					this.$refs[chartName].showSeries(name);
				}
				else{
					currentElement.style.boxShadow = "";
					this.$refs[chartName].hideSeries(name);
				}
				break;
			case"Position":
				if(currentElement.style.boxShadow == "") {
					currentElement.style.boxShadow = "0px 0px 10px 2px #FF9F43";
					this.$refs[chartName].showSeries("Position Moyenne");
				}
				else{
					currentElement.style.boxShadow = "";
					this.$refs[chartName].hideSeries("Position Moyenne");
				}
				break;
			}
		},

		getChartPopupKeywordsData(keyword){
			return new Promise((resolve, reject) => {
				this.$http.get(this.apiUrl + "webmaster/gscKwData/" + this.$props.societyId + "/" + keyword.replace("'", "%5C%27") + "/" + this.$props.fromDate + "/" + this.$props.toDate).then(result => {
					resolve(result.data);
				})
					.catch(err => {
						//console.log(err);
						reject([]);
					});
			});
		},

		showLineChartPopup(keyword){
			this.getChartPopupKeywordsData(keyword).then(data => {
				//console.log("showLineChartPopup", data);
				let fromDate = new Date(this.$props.fromDate);
				let toDate = new Date(this.$props.toDate);

				let xaxisDates = [];

				let startMonth = fromDate.getMonth();
				let startYear = fromDate.getFullYear();
				while(startYear <= toDate.getFullYear()){
					if(startYear < toDate.getFullYear()){
						while(startMonth <= 11){


							if(startMonth + 1 < 10){
								xaxisDates.push(`${startYear}-0${startMonth + 1}`);
							}
							else{
								xaxisDates.push(`${startYear}-${startMonth + 1}`);
							}
							startMonth = startMonth + 1;
						}
					}
					else{
						while(startMonth <= toDate.getMonth()){
							if(startMonth + 1 < 10){
								xaxisDates.push(`${startYear}-0${startMonth + 1}`);
							}
							else{
								xaxisDates.push(`${startYear}-${startMonth + 1}`);
							}
							startMonth = startMonth + 1;
						}
					}

					startMonth = 0;
					startYear = startYear + 1;
				}

				xaxisDates = xaxisDates.map(date => date.split("-").reverse().join("/"));

				let chartParamPopup = {
					keys: {data: [], name: "key"},
					imp: {data: [], name: "Impressions"},
					clicks: {data: [], name: "Clics"},
					ctr: {data: [], name: "CTR"},
					pos: {data: [], name: "Position"}
				};

				// SORT data
				for(let i = 0; i < data.length; i++){
					chartParamPopup.imp.data.push(Math.trunc(data[i].impressions));
					chartParamPopup.clicks.data.push(data[i].clicks ? Math.trunc(data[i].clicks) : 0);
					let ctr = data[i].impressions > 0 ? (data[i].clicks / data[i].impressions) * 100 : 0;

					chartParamPopup.ctr.data.push(parseFloat(ctr.toFixed(2)));
					chartParamPopup.pos.data.push(Math.trunc(data[i].position));
				}

				this.$emit("show-line-chart-popup", [chartParamPopup, xaxisDates]);
			});

		},
		convertKeywordToGoogleSearchUrl(keyword){
			let baseUrl = "https://www.google.com/search?q=";
			let formatedKeyword = keyword.replace(/ /g, "+");
			return baseUrl + formatedKeyword;
		},
		openLoadingContainer(containerId){
			if(this.$refs[containerId]){
				this.$vs.loading({
					container: "#" + containerId
				});
			}
		},
		closeLoadingContainer(containerId){
			this.$vs.loading.close("#" + containerId + " > .con-vs-loading");
		}
	},
};
</script>
<style lang="scss" scoped>
.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
.txt_align_right {
  text-align: right !important;
}
.th_width {
  width: 150px;
}
.th_padding {
  padding-right: 30px;
}
@media screen and (max-width: 500px) {
  .th_width {
    max-width: 150px;
  }
}
.pointer {
  cursor: pointer;
}
</style>